/**
 * 工具类
 * @author penghj
 * @returns {boolean}
 */

/** 校验数值为小数或者整数 **/
export const validNumber = function (amount) {
    const regex = /^-?\d+(\.\d{0,2})?$/;
    // 检查是否为数字
    if (!regex.test(amount)) {
        return false; // 不是数字
    }
    // 转换为数字并检查是否大于0
    const number = parseFloat(amount);
    return number > 0;
}
export const validAmount = function (amount) {
    const regex = /^\d+(\.\d{0,2})?$/;
    return regex.test(amount);
}
const validAmountDigit = function (amount) {
    const regex = /^\d{1,8}(\.\d{1,2})?$/;
    return regex.test(amount);
}

const endsWithDecimalPoint = function (amount) {
    return /^\d+(\.\d+)?$/.test(amount);
}

/** 校验输入数字1到10位及最大值 **/
export const validAmountMax = function (amount) {
    const number = parseFloat(amount);
    return number < 1000000000;
}

// 防重提交方法
export const debounce = function(func, wait, immediate) {
    let timeout;
    return function() {
        let context = this, args = arguments;
        let later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}


export default {
    debounce: debounce,
    validNumber: validNumber,
    validAmount: validAmount,
    validAmountMax: validAmountMax,
    endsWithDecimalPoint: endsWithDecimalPoint,
    validAmountDigit: validAmountDigit
}
